import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { AuthService, ScreenService } from 'core/services';
import { ClientErrorPresenter } from './presenter';

export const ClientError: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          {ScreenService.getDocumentTitle(
            t('ui.pages.Error.ClientError.title'),
          )}
        </title>
      </Helmet>
      <ClientErrorPresenter showNavigator={!!AuthService.getSession()} />
    </>
  );
};
